
export enum TypeAhead {
    MottagningsplatsTerminalorder = "mottagningsplatsTerminalorderTypeAhead",
    MottagningsplatsKundorder = "mottagningsplatsKundorderTypeAhead",
    Handelssortiment = "handelssortimentTypeAhead",
    Leverantorsnamn = "leverantorsnamnTypeAhead",
    Kundnamn = "kundnamnTypeAhead",
    TerminalKund = "TerminalKund",
    TerminalCkLeverantor = "TerminalCkLeverantor",
    AnsvarigLogistiker = "AnsvarigLogistiker",
    SDCMottagningsplats = "SDCMottagningsplats",
    Land = "Land"
}
